import * as React from "react";
import { useRef } from "react";
import styled, { css } from "styled-components";
import useIntersectionObserver from "hooks/useIntersectionObserver";
import ScrollShadow from "theme/box-shadows/ScrollShadow";
const Container = styled.div`
  height: 100%;
  display: flex;
  flex-flow: column nowrap;
`;
const ScrollContainer = styled.div`
  overflow-y: auto;
`;
const Content = styled.div`
  position: relative;
`;
const Actions = styled.div(
  ({ theme, $scrolledToBottom, $alignAtBottom }) => css`
    position: sticky;
    width: 100%;
    bottom: 0;
    background: ${theme.colors.global.contentBackground};
    z-index: 1;
    display: flex;
    flex-direction: column;
    flex: 1;
    justify-content: ${$alignAtBottom ? "flex-end" : "space-between"};
    padding-top: 5px;

    ${ScrollShadow("top")}
    &::before {
      display: ${$scrolledToBottom ? "block" : "none"};
    }
  `
);
const ScrolledToBottomIndicator = styled.div`
  width: 1px;
  position: absolute;
  bottom: 0;
  height: 5px;
  z-index: 0;
`;
const StickyBottomActions = ({ actions, children, className = void 0, alignActionsAtBottom = false }) => {
  const scrollContainerRef = useRef();
  const scrolledToBottomIndicatorRef = useRef();
  const scrolledToBottom = useIntersectionObserver(scrollContainerRef, scrolledToBottomIndicatorRef);
  return /* @__PURE__ */ React.createElement(Container, { className }, /* @__PURE__ */ React.createElement(ScrollContainer, { ref: scrollContainerRef }, /* @__PURE__ */ React.createElement(Content, null, children, /* @__PURE__ */ React.createElement(ScrolledToBottomIndicator, { ref: scrolledToBottomIndicatorRef }))), /* @__PURE__ */ React.createElement(Actions, { $scrolledToBottom: scrolledToBottom, $alignAtBottom: alignActionsAtBottom }, actions));
};
export default StickyBottomActions;
